/** Keep distinct usage roles, but do not display the same avatar relationship twice. */
export default function getMediaFileSecondaryConnections({ primaryCharacter, connections, }) {
    if (primaryCharacter?.kind !== "avatar") {
        return connections;
    }
    return connections.filter((connection) => connection.id !== primaryCharacter.id);
}
